import type { DefaultTranslationsObject, Language } from '../types.js'

export const taTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'கணக்கு',
    accountOfCurrentUser: 'தற்போதைய பயனரின் கணக்கு',
    accountVerified: 'கணக்கு வெற்றிகரமாக சரிபார்க்கப்பட்டது.',
    alreadyActivated: 'ஏற்கனவே செயல்படுத்தப்பட்டது',
    alreadyLoggedIn: 'ஏற்கனவே உள்நுழைந்துள்ளீர்கள்',
    apiKey: 'API விசை',
    authenticated: 'அங்கீகரிக்கப்பட்டது',
    backToLogin: 'உள்நுழைவுக்கு திரும்ப',
    beginCreateFirstUser: 'தொடங்க, உங்கள் முதல் பயனரை உருவாக்கவும்.',
    changePassword: 'கடவுச்சொல்லை மாற்று',
    checkYourEmailForPasswordReset:
      'இந்த மின்னஞ்சல் முகவரி ஒரு கணக்குடன் இணைக்கப்பட்டிருந்தால், விரைவில் உங்கள் கடவுச்சொல்லை மீட்டமைக்கும் வழிமுறைகள் அனுப்பப்படும். உங்கள் இன்பாக்ஸில் இல்லாவிட்டால், "Spam/Junk" கோப்புறையைச் சரிபார்க்கவும்.',
    confirmGeneration: 'உருவாக்கலை உறுதிப்படுத்து',
    confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து',
    createFirstUser: 'முதல் பயனரை உருவாக்கவும்',
    emailNotValid: 'கொடுக்கப்பட்ட மின்னஞ்சல் செல்லுபடியானதல்ல',
    emailOrUsername: 'மின்னஞ்சல் அல்லது பயனர் பெயர்',
    emailSent: 'மின்னஞ்சல் அனுப்பப்பட்டது',
    emailVerified: 'மின்னஞ்சல் வெற்றிகரமாக சரிபார்க்கப்பட்டது.',
    enableAPIKey: 'API விசையை இயக்கவும்',
    failedToUnlock: 'திறக்க முடியவில்லை',
    forceUnlock: 'கட்டாயமாக திற',
    forgotPassword: 'கடவுச்சொல் மறந்துவிட்டதா?',
    forgotPasswordEmailInstructions:
      'தயவுசெய்து கீழே உங்கள் மின்னஞ்சலை உள்ளிடவும். கடவுச்சொல்லை மீட்டமைக்கும் வழிமுறைகள் கொண்ட மின்னஞ்சல் உங்களுக்கு அனுப்பப்படும்.',
    forgotPasswordQuestion: 'கடவுச்சொல் மறந்துவிட்டதா?',
    forgotPasswordUsernameInstructions:
      'தயவுசெய்து கீழே உங்கள் பயனர் பெயரை உள்ளிடவும். கடவுச்சொல்லை மீட்டமைக்கும் வழிமுறைகள் அந்த பயனர் பெயருடன் இணைக்கப்பட்ட மின்னஞ்சலுக்கு அனுப்பப்படும்.',
    generate: 'உருவாக்கு',
    generateNewAPIKey: 'புதிய API விசையை உருவாக்கு',
    generatingNewAPIKeyWillInvalidate:
      'புதிய API விசையை உருவாக்குவது முன்பு பயன்படுத்திய விசையை <1>செல்லாது</1> ஆக்கும். நீங்கள் தொடர விரும்புகிறீர்களா?',
    lockUntil: 'இவ்வரை பூட்டப்பட்டுள்ளது',
    logBackIn: 'மீண்டும் உள்நுழைக',
    loggedIn: 'மற்றொரு பயனராக உள்நுழைய, முதலில் <0>வெளியேறு</0> வேண்டும்.',
    loggedInChangePassword: 'கடவுச்சொல்லை மாற்ற, உங்கள் <0>கணக்கு</0> பகுதிக்கு சென்று மாற்றவும்.',
    loggedOutInactivity: 'செயலற்றதினால் நீங்கள் வெளியேற்றப்பட்டுள்ளீர்கள்.',
    loggedOutSuccessfully: 'நீங்கள் வெற்றிகரமாக வெளியேறியுள்ளீர்கள்.',
    loggingOut: 'வெளியேறுகிறது...',
    login: 'உள்நுழைக',
    loginAttempts: 'உள்நுழைவு முயற்சிகள்',
    loginUser: 'பயனரை உள்நுழை',
    loginWithAnotherUser: 'மற்றொரு பயனராக உள்நுழைய, முதலில் <0>வெளியேறு</0> வேண்டும்.',
    logOut: 'வெளியேறு',
    logout: 'வெளியேறு',
    logoutSuccessful: 'வெற்றிகரமாக வெளியேறப்பட்டது.',
    logoutUser: 'பயனரை வெளியேற்று',
    newAccountCreated:
      'உங்களுக்கு ஒரு புதிய கணக்கு உருவாக்கப்பட்டுள்ளது <a href="{{serverURL}}">{{serverURL}}</a> அணுக. உங்கள் மின்னஞ்சலை சரிபார்க்க, பின்வரும் இணைப்பைக் கிளிக் செய்யவும் அல்லது உலாவியில் URL ஐ ஒட்டவும்: <a href="{{verificationURL}}">{{verificationURL}}</a><br> மின்னஞ்சல் சரிபார்த்த பின், வெற்றிகரமாக உள்நுழையலாம்.',
    newAPIKeyGenerated: 'புதிய API விசை உருவாக்கப்பட்டது.',
    newPassword: 'புதிய கடவுச்சொல்',
    passed: 'அங்கீகாரம் நிறைவேற்றப்பட்டது',
    passwordResetSuccessfully: 'கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது.',
    resetPassword: 'கடவுச்சொல்லை மீட்டமை',
    resetPasswordExpiration: 'கடவுச்சொல் மீட்டமைக்க வேண்டிய காலம்',
    resetPasswordToken: 'கடவுச்சொல் மீட்டமைப்பு டோக்கன்',
    resetYourPassword: 'உங்கள் கடவுச்சொல்லை மீட்டமைக்கவும்',
    stayLoggedIn: 'உள்நுழைந்தபடி இரு',
    successfullyRegisteredFirstUser: 'முதல் பயனர் வெற்றிகரமாக பதிவு செய்யப்பட்டார்.',
    successfullyUnlocked: 'வெற்றிகரமாக திறக்கப்பட்டது',
    tokenRefreshSuccessful: 'டோக்கன் புதுப்பிப்பு வெற்றிகரமாக முடிந்தது.',
    unableToVerify: 'சரிபார்க்க முடியவில்லை',
    username: 'பயனர் பெயர்',
    usernameNotValid: 'கொடுக்கப்பட்ட பயனர் பெயர் செல்லுபடியானதல்ல',
    verified: 'சரிபார்க்கப்பட்டது',
    verifiedSuccessfully: 'வெற்றிகரமாக சரிபார்க்கப்பட்டது',
    verify: 'சரிபார்க்கவும்',
    verifyUser: 'பயனரை சரிபார்க்கவும்',
    verifyYourEmail: 'உங்கள் மின்னஞ்சலை சரிபார்க்கவும்',
    youAreInactive:
      'நீங்கள் சில நேரமாக செயலற்றிருக்கிறீர்கள். உங்கள் பாதுகாப்பிற்காக விரைவில் தானாகவே வெளியேற்றப்படுவீர்கள். உள்நுழைந்தபடி இருக்க விரும்புகிறீர்களா?',
    youAreReceivingResetPassword:
      'நீங்கள் (அல்லது மற்றொருவர்) உங்கள் கணக்கின் கடவுச்சொல்லை மீட்டமைக்க கோரியதால் இந்த மின்னஞ்சலைப் பெறுகிறீர்கள். செயல்முறையை முடிக்க, பின்வரும் இணைப்பைக் கிளிக் செய்யவும் அல்லது அதை உலாவியில் ஒட்டவும்:',
    youDidNotRequestPassword:
      'இதை நீங்கள் கோரவில்லை என்றால், இந்த மின்னஞ்சலை புறக்கணிக்கவும். உங்கள் கடவுச்சொல் மாறாது இருக்கும்.',
  },
  dashboard: {
    addWidget: 'விக்கெட் சேர்',
    deleteWidget: '{{id}} விட்ஜெடை நீக்கு',
    searchWidgets: 'தேடல் கருவிகள்...',
  },
  error: {
    accountAlreadyActivated: 'இந்த கணக்கு ஏற்கனவே செயல்படுத்தப்பட்டுள்ளது.',
    autosaving: 'இந்த ஆவணத்தை தானாகச் சேமிக்கும் போது ஒரு பிரச்சனை ஏற்பட்டது.',
    correctInvalidFields: 'தயவுசெய்து தவறான புலங்களைச் சரிசெய்யவும்.',
    deletingFile: 'கோப்பை நீக்கும் போது பிழை ஏற்பட்டது.',
    deletingTitle:
      '{{title}}-ஐ நீக்கும் போது பிழை ஏற்பட்டது. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    documentNotFound:
      'ID {{id}} கொண்ட ஆவணம் காணப்படவில்லை. அது நீக்கப்பட்டிருக்கலாம் அல்லது இல்லாமல் இருக்கலாம், அல்லது உங்களுக்கு அதற்கான அணுகல் அனுமதி இல்லாமல் இருக்கலாம்.',
    emailOrPasswordIncorrect: 'கொடுக்கப்பட்ட மின்னஞ்சல் அல்லது கடவுச்சொல் தவறானது.',
    followingFieldsInvalid_one: 'பின்வரும் புலம் தவறானது:',
    followingFieldsInvalid_other: 'பின்வரும் புலங்கள் தவறானவை:',
    incorrectCollection: 'தவறான தொகுப்பு',
    insufficientClipboardPermissions:
      'கிளிப்போர்டு அணுகல் மறுக்கப்பட்டது. தயவுசெய்து கிளிப்போர்டு அனுமதிகளைச் சரிபார்க்கவும்.',
    invalidClipboardData: 'செல்லுபடியற்ற கிளிப்போர்டு தரவு.',
    invalidFileType: 'செல்லுபடியற்ற கோப்பு வகை',
    invalidFileTypeValue: 'செல்லுபடியற்ற கோப்பு வகை: {{value}}',
    invalidRequestArgs: 'விண்ணப்பத்தில் தவறான அளவுருக்கள் அனுப்பப்பட்டுள்ளன: {{args}}',
    loadingDocument: 'ID {{id}} கொண்ட ஆவணத்தை ஏற்றும் போது ஒரு பிரச்சனை ஏற்பட்டது.',
    localesNotSaved_one: 'பின்வரும் மொழி சேமிக்கப்படவில்லை:',
    localesNotSaved_other: 'பின்வரும் மொழிகள் சேமிக்கப்படவில்லை:',
    logoutFailed: 'வெளியேற்றம் தோல்வியடைந்தது.',
    missingEmail: 'மின்னஞ்சல் காணப்படவில்லை.',
    missingIDOfDocument: 'புதுப்பிக்க வேண்டிய ஆவணத்தின் ID காணப்படவில்லை.',
    missingIDOfVersion: 'பதிப்பின் ID காணப்படவில்லை.',
    missingRequiredData: 'தேவையான தரவு காணப்படவில்லை.',
    noFilesUploaded: 'எந்தக் கோப்புகளும் பதிவேற்றப்படவில்லை.',
    noMatchedField: '"{{label}}" க்கான பொருத்தமான புலம் கிடைக்கவில்லை.',
    notAllowedToAccessPage: 'இந்தப் பக்கத்தை அணுக உங்களுக்கு அனுமதி இல்லை.',
    notAllowedToPerformAction: 'இந்த செயல்பாட்டை செய்ய உங்களுக்கு அனுமதி இல்லை.',
    notFound: 'கோரிய வளம் கிடைக்கவில்லை.',
    noUser: 'பயனர் இல்லை',
    previewing: 'இந்த ஆவணத்தை முன்னோட்டம் பார்க்கும்போது பிழை ஏற்பட்டது.',
    problemUploadingFile: 'கோப்பைப் பதிவேற்றும்போது பிரச்சனை ஏற்பட்டது.',
    restoringTitle:
      '{{title}}-ஐ மீட்டமைக்கும் போது பிழை ஏற்பட்டது. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    tokenInvalidOrExpired: 'டோக்கன் தவறானது அல்லது காலாவதியானது.',
    tokenNotProvided: 'டோக்கன் வழங்கப்படவில்லை.',
    unableToCopy: 'நகலெடுக்க முடியவில்லை.',
    unableToDeleteCount: '{{total}} {{label}}-இல் {{count}}-ஐ நீக்க முடியவில்லை.',
    unableToReindexCollection:
      'தொகுப்பு {{collection}}-ஐ மறுஅட்டவணைப்படுத்தும் போது பிழை. செயல் நிறுத்தப்பட்டது.',
    unableToUpdateCount: '{{total}} {{label}}-இல் {{count}}-ஐ புதுப்பிக்க முடியவில்லை.',
    unauthorized: 'அனுமதி இல்லை, இந்த கோரிக்கையைச் செய்ய உள்நுழைய வேண்டும்.',
    unauthorizedAdmin: 'அனுமதி இல்லை, இந்த பயனருக்கு நிர்வாகப் பலகையை அணுக முடியாது.',
    unknown: 'அறியப்படாத பிழை ஏற்பட்டுள்ளது.',
    unPublishingDocument: 'இந்த ஆவணத்தை வெளியீட்டிலிருந்து நீக்கும் போது பிழை ஏற்பட்டது.',
    unspecific: 'ஒரு பிழை ஏற்பட்டுள்ளது.',
    unverifiedEmail: 'உள்நுழைவதற்கு முன் உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்.',
    userEmailAlreadyRegistered: 'கொடுக்கப்பட்ட மின்னஞ்சல் ஏற்கனவே பதிவுசெய்யப்பட்டுள்ளது.',
    userLocked: 'பல தவறான உள்நுழைவு முயற்சிகளால் இந்த பயனர் பூட்டப்பட்டுள்ளார்.',
    usernameAlreadyRegistered: 'கொடுக்கப்பட்ட பயனர் பெயர் ஏற்கனவே பதிவுசெய்யப்பட்டுள்ளது.',
    usernameOrPasswordIncorrect: 'கொடுக்கப்பட்ட பயனர் பெயர் அல்லது கடவுச்சொல் தவறானது.',
    valueMustBeUnique: 'மதிப்பு தனித்துவமானதாக இருக்க வேண்டும்.',
    verificationTokenInvalid: 'சரிபார்ப்பு டோக்கன் தவறானது.',
  },
  fields: {
    addLabel: '{{label}} சேர்க்கவும்',
    addLink: 'இணைப்பைச் சேர்க்கவும்',
    addNew: 'புதியதைச் சேர்க்கவும்',
    addNewLabel: 'புதிய {{label}} சேர்க்கவும்',
    addRelationship: 'உறவைக் (Relationship) சேர்க்கவும்',
    addUpload: 'பதிவேற்றத்தைச் சேர்க்கவும்',
    block: 'தொகுதி',
    blocks: 'தொகுதிகள்',
    blockType: 'தொகுதி வகை',
    chooseBetweenCustomTextOrDocument:
      'தனிப்பயன் உரை URL ஒன்றை உள்ளிடவோ அல்லது மற்றொரு ஆவணத்தை இணைக்கவோ தேர்வு செய்யவும்.',
    chooseDocumentToLink: 'இணைக்க வேண்டிய ஆவணத்தைத் தேர்வு செய்யவும்',
    chooseFromExisting: 'இருப்பவற்றில் இருந்து தேர்வு செய்யவும்',
    chooseLabel: '{{label}} தேர்வு செய்யவும்',
    collapseAll: 'அனைத்தையும் சுருக்கவும்',
    customURL: 'தனிப்பயன் URL',
    editLabelData: '{{label}} தரவைத் திருத்தவும்',
    editLink: 'இணைப்பைத் திருத்தவும்',
    editRelationship: 'உறவைக் (Relationship) திருத்தவும்',
    enterURL: 'ஒரு URL ஐ உள்ளிடவும்',
    internalLink: 'உள் இணைப்பு',
    itemsAndMore: '{{items}} மற்றும் மேலும் {{count}}',
    labelRelationship: '{{label}} உறவு',
    latitude: 'அகலாங்கு',
    linkedTo: '<0>{{label}}</0> க்கு இணைக்கப்பட்டுள்ளது',
    linkType: 'இணைப்பு வகை',
    longitude: 'நெடாங்கு',
    newLabel: 'புதிய {{label}}',
    openInNewTab: 'புதிய தாவலில் திறக்கவும்',
    passwordsDoNotMatch: 'கடவுச்சொற்கள் பொருந்தவில்லை.',
    relatedDocument: 'தொடர்புடைய ஆவணம்',
    relationTo: 'உறவு',
    removeRelationship: 'உறவை நீக்கவும்',
    removeUpload: 'பதிவேற்றத்தை நீக்கவும்',
    saveChanges: 'மாற்றங்களைச் சேமிக்கவும்',
    searchForBlock: 'தொகுதியைத் தேடவும்',
    searchForLanguage: 'ஒரு மொழியைத் தேடு',
    selectExistingLabel: 'இருப்பில் உள்ள {{label}} தேர்வு செய்யவும்',
    selectFieldsToEdit: 'திருத்த வேண்டிய புலங்களைத் தேர்வு செய்யவும்',
    showAll: 'அனைத்தையும் காட்டு',
    swapRelationship: 'உறவை மாற்றவும்',
    swapUpload: 'பதிவேற்றத்தை மாற்றவும்',
    textToDisplay: 'காட்ட வேண்டிய உரை',
    toggleBlock: 'தொகுதியை மாற்றவும்',
    uploadNewLabel: 'புதிய {{label}} பதிவேற்றவும்',
  },
  folder: {
    browseByFolder: 'கோப்புறைகளில் உலாவவும்',
    byFolder: 'கோப்புறை அடிப்படையில்',
    deleteFolder: 'கோப்புறையை நீக்கவும்',
    folderName: 'கோப்புறை பெயர்',
    folders: 'கோப்புறைகள்',
    folderTypeDescription:
      'இந்த கோப்புறையில் எந்த வகை தொகுப்பின் ஆவணங்கள் அனுமதிக்கப்பட வேண்டும் என்பதைக் தேர்வு செய்யவும்.',
    itemHasBeenMoved: '{{title}} "{{folderName}}" கோப்புறைக்கு நகர்த்தப்பட்டது.',
    itemHasBeenMovedToRoot: '{{title}} மூல (root) கோப்புறைக்கு நகர்த்தப்பட்டது.',
    itemsMovedToFolder: '{{title}} "{{folderName}}" கோப்புறைக்கு நகர்த்தப்பட்டது.',
    itemsMovedToRoot: '{{title}} மூல (root) கோப்புறைக்கு நகர்த்தப்பட்டது.',
    moveFolder: 'கோப்புறையை நகர்த்தவும்',
    moveItemsToFolderConfirmation:
      'நீங்கள் <1>{{count}} {{label}}</1>-ஐ <2>{{toFolder}}</2>-க்கு நகர்த்தவிருக்கிறீர்கள். தொடர விரும்புகிறீர்களா?',
    moveItemsToRootConfirmation:
      'நீங்கள் <1>{{count}} {{label}}</1>-ஐ மூல (root) கோப்புறைக்கு நகர்த்தவிருக்கிறீர்கள். தொடர விரும்புகிறீர்களா?',
    moveItemToFolderConfirmation:
      'நீங்கள் <1>{{title}}</1>-ஐ <2>{{toFolder}}</2>-க்கு நகர்த்தவிருக்கிறீர்கள். தொடர விரும்புகிறீர்களா?',
    moveItemToRootConfirmation:
      'நீங்கள் <1>{{title}}</1>-ஐ மூல (root) கோப்புறைக்கு நகர்த்தவிருக்கிறீர்கள். தொடர விரும்புகிறீர்களா?',
    movingFromFolder: '{{fromFolder}}-இருந்து {{title}} நகர்த்தப்படுகிறது',
    newFolder: 'புதிய கோப்புறை',
    noFolder: 'கோப்புறை இல்லை',
    renameFolder: 'கோப்புறை பெயரை மாற்றவும்',
    searchByNameInFolder: '{{folderName}}-இல் பெயரால் தேடவும்',
    selectFolderForItem: '{{title}}-க்கான கோப்புறையை தேர்வு செய்யவும்',
  },
  general: {
    name: 'பெயர்',
    aboutToDelete: '{{label}} <1>{{title}}</1>-ஐ நீக்கவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToDeleteCount_many: '{{count}} {{label}}-ஐ நீக்கவிருக்கிறீர்கள்',
    aboutToDeleteCount_one: '{{count}} {{label}}-ஐ நீக்கவிருக்கிறீர்கள்',
    aboutToDeleteCount_other: '{{count}} {{label}}-ஐ நீக்கவிருக்கிறீர்கள்',
    aboutToPermanentlyDelete:
      '{{label}} <1>{{title}}</1>-ஐ நிரந்தரமாக நீக்கவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToPermanentlyDeleteTrash:
      'குப்பையில் உள்ள <0>{{count}}</0> <1>{{label}}</1>-ஐ நிரந்தரமாக நீக்கவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToRestore: '{{label}} <1>{{title}}</1>-ஐ மீட்டெடுக்கவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToRestoreAsDraft:
      '{{label}} <1>{{title}}</1>-ஐ வரைவு (draft) ஆக மீட்டெடுக்கவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToRestoreAsDraftCount: '{{count}} {{label}}-ஐ வரைவு (draft) ஆக மீட்டெடுக்கவிருக்கிறீர்கள்',
    aboutToRestoreCount: '{{count}} {{label}}-ஐ மீட்டெடுக்கவிருக்கிறீர்கள்',
    aboutToTrash: '{{label}} <1>{{title}}</1>-ஐ குப்பைக்கு நகர்த்தவிருக்கிறீர்கள். உறுதியாகவா?',
    aboutToTrashCount: '{{count}} {{label}}-ஐ குப்பைக்கு நகர்த்தவிருக்கிறீர்கள்',
    addBelow: 'கீழே சேர்க்கவும்',
    addFilter: 'வடிகட்டியைச் சேர்க்கவும்',
    adminTheme: 'நிர்வாக கருப்பொருள்',
    all: 'அனைத்தும்',
    allCollections: 'அனைத்து தொகுப்புகள்',
    allLocales: 'அனைத்து மொழிகள்',
    and: 'மற்றும்',
    anotherUser: 'மற்றொரு பயனர்',
    anotherUserTakenOver: 'இந்த ஆவணத்தை மற்றொரு பயனர் திருத்திக் கொண்டிருக்கிறார்.',
    applyChanges: 'மாற்றங்களைப் பயன்படுத்தவும்',
    ascending: 'ஏறுவரிசை',
    automatic: 'தானியங்கி',
    backToDashboard: 'கட்டுப்பாட்டு பலகைக்கு திரும்பவும்',
    cancel: 'ரத்து செய்',
    changesNotSaved: 'உங்கள் மாற்றங்கள் சேமிக்கப்படவில்லை. இப்போது வெளியேறினால், அவை இழக்கப்படும்.',
    clear: 'அழிக்கவும்',
    clearAll: 'அனைத்தையும் அழிக்கவும்',
    close: 'மூடவும்',
    collapse: 'சுருக்கவும்',
    collections: 'தொகுப்புகள்',
    columns: 'நெடுவரிசைகள்',
    columnToSort: 'வரிசைப்படுத்த வேண்டிய நெடுவரிசை',
    confirm: 'உறுதிசெய்',
    confirmCopy: 'நகலை உறுதிசெய்',
    confirmDeletion: 'நீக்கலை உறுதிசெய்',
    confirmDuplication: 'நகலெடுப்பை உறுதிசெய்',
    confirmMove: 'நகர்த்தலை உறுதிசெய்',
    confirmReindex: 'அனைத்து {{collections}}-ஐ மறுஇணைப்பு செய்யவா?',
    confirmReindexAll: 'அனைத்து தொகுப்புகளையும் மறுஇணைப்பு செய்யவா?',
    confirmReindexDescription:
      'இது ஏற்கனவே உள்ள குறியீடுகளை (indexes) நீக்கி {{collections}} உள்ள ஆவணங்களை மறுஇணைக்கும்.',
    confirmReindexDescriptionAll:
      'இது ஏற்கனவே உள்ள குறியீடுகளை (indexes) நீக்கி அனைத்து தொகுப்புகளையும் மறுஇணைக்கும்.',
    confirmRestoration: 'மீட்டெடுப்பை உறுதிசெய்',
    copied: 'நகலெடுக்கப்பட்டது',
    copy: 'நகலெடுக்கவும்',
    copyField: 'புலத்தை நகலெடுக்கவும்',
    copying: 'நகலெடுக்கிறது...',
    copyRow: 'வரிசையை நகலெடுக்கவும்',
    copyWarning:
      '{{label}} {{title}}-க்கு {{to}}-ஐ {{from}}-ஆல் மீளெழுதவிருக்கிறீர்கள். உறுதியாகவா?',
    create: 'உருவாக்கு',
    created: 'உருவாக்கப்பட்டது',
    createdAt: 'உருவாக்கப்பட்ட நாள்',
    createNew: 'புதியது உருவாக்கு',
    createNewLabel: 'புதிய {{label}} உருவாக்கு',
    creating: 'உருவாக்குகிறது...',
    creatingNewLabel: 'புதிய {{label}} உருவாக்கப்படுகிறது',
    currentlyEditing:
      'இந்த ஆவணத்தை தற்போது திருத்துகிறார். நீங்கள் ஏற்கொண்டால், அவரின் அணுகல் நிறுத்தப்படும் மற்றும் சேமிக்காத மாற்றங்கள் இழக்கப்படலாம்.',
    custom: 'விருப்பம்',
    dark: 'இருள்',
    dashboard: 'கட்டுப்பாட்டு பலகை',
    delete: 'நீக்கு',
    deleted: 'நீக்கப்பட்டது',
    deletedAt: 'நீக்கப்பட்ட நாள்',
    deletedCountSuccessfully: '{{count}} {{label}} வெற்றிகரமாக நீக்கப்பட்டது.',
    deletedSuccessfully: 'வெற்றிகரமாக நீக்கப்பட்டது.',
    deleteLabel: '{{label}}-ஐ நீக்கு',
    deletePermanently: 'குப்பையைத் தவிர்த்து நிரந்தரமாக நீக்கு',
    deleting: 'நீக்குகிறது...',
    depth: 'ஆழம்',
    descending: 'இறங்குமுகம்',
    deselectAllRows: 'அனைத்து வரிசைகளையும் நீக்கு',
    document: 'ஆவணம்',
    documentIsTrashed: 'இந்த {{label}} குப்பையில் உள்ளது மற்றும் வாசிப்பதற்கு மட்டும்.',
    documentLocked: 'ஆவணம் பூட்டப்பட்டுள்ளது',
    documents: 'ஆவணங்கள்',
    duplicate: 'நகலெடு',
    duplicateWithoutSaving: 'மாற்றங்களைச் சேமிக்காமல் நகலெடு',
    edit: 'தொகு',
    editAll: 'அனைத்தையும் தொகு',
    editedSince: 'இதிலிருந்து தொகுக்கப்பட்டது',
    editing: 'தொகுக்கிறது',
    editingLabel_many: '{{count}} {{label}}-ஐத் தொகுக்கிறது',
    editingLabel_one: '{{count}} {{label}}-ஐத் தொகுக்கிறது',
    editingLabel_other: '{{count}} {{label}}-ஐத் தொகுக்கிறது',
    editingTakenOver: 'தொகுத்தல் கையகப்படுத்தப்பட்டது',
    editLabel: '{{label}}-ஐத் தொகு',
    email: 'மின்னஞ்சல்',
    emailAddress: 'மின்னஞ்சல் முகவரி',
    emptyTrash: 'குப்பையை காலி செய்',
    emptyTrashLabel: '{{label}} குப்பையை காலி செய்',
    enterAValue: 'ஒரு மதிப்பை உள்ளிடவும்',
    error: 'பிழை',
    errors: 'பிழைகள்',
    exitLivePreview: 'நேரடி முன்னோட்டத்திலிருந்து வெளியேறு',
    export: 'ஏற்றுமதி',
    fallbackToDefaultLocale: 'இயல்புநிலை மொழிக்கு மாறுக',
    false: 'பொய்',
    filter: 'வடிகட்டு',
    filters: 'வடிகட்டிகள்',
    filterWhere: '{{label}}-ஐ வடிகட்டு',
    globals: 'பொதுவானவை',
    goBack: 'மீண்டும் செல்',
    groupByLabel: '{{label}}-ஆல் குழுபடுத்து',
    import: 'இறக்குமதி',
    isEditing: 'தொகுக்கிறது',
    item: 'உருப்படி',
    items: 'உருப்படிகள்',
    language: 'மொழி',
    lastModified: 'கடைசியாக மாற்றப்பட்டது',
    leaveAnyway: 'எப்படியும் விட்டு செல்',
    leaveWithoutSaving: 'சேமிக்காமல் விட்டு செல்',
    light: 'ஒளி',
    livePreview: 'நேரடி முன்னோட்டம்',
    loading: 'ஏற்றுகிறது',
    locale: 'மொழி அமைவு',
    locales: 'மொழி அமைவுகள்',
    lock: 'பூட்டு',
    menu: 'மெனு',
    moreOptions: 'மேலும் விருப்பங்கள்',
    move: 'நகர்த்து',
    moveConfirm:
      '{{count}} {{label}}-ஐ <1>{{destination}}</1>-க்கு நகர்த்த உள்ளீர்கள். உறுதியாக உள்ளீர்களா?',
    moveCount: '{{count}} {{label}} நகர்த்துக',
    moveDown: 'கீழே நகர்த்து',
    moveUp: 'மேலே நகர்த்து',
    moving: 'நகர்த்துகிறது',
    movingCount: '{{count}} {{label}} நகர்த்தப்படுகிறது',
    newLabel: 'புதிய {{label}}',
    newPassword: 'புதிய கடவுச்சொல்',
    next: 'அடுத்து',
    no: 'இல்லை',
    noDateSelected: 'தேதி எதுவும் தேர்ந்தெடுக்கப்படவில்லை',
    noFiltersSet: 'வடிகட்டிகள் எதுவும் அமைக்கப்படவில்லை',
    noLabel: '<{{label}} இல்லை>',
    none: 'ஒன்றுமில்லை',
    noOptions: 'விருப்பங்கள் எதுவும் இல்லை',
    noResults:
      'எந்த {{label}} கிடைக்கவில்லை. இன்னும் {{label}} இல்லை அல்லது நீங்கள் தேர்ந்தெடுத்த வடிகட்டுகளுக்கு பொருந்தவில்லை.',
    notFound: 'கிடைக்கவில்லை',
    nothingFound: 'எதுவும் கிடைக்கவில்லை',
    noTrashResults: 'குப்பையில் {{label}} எதுவும் இல்லை.',
    noUpcomingEventsScheduled: 'எந்த வரவிருக்கும் நிகழ்ச்சிகளும் இல்லை.',
    noValue: 'மதிப்பு இல்லை',
    of: 'இன்',
    only: 'மட்டும்',
    open: 'திற',
    or: 'அல்லது',
    order: 'வரிசை',
    overwriteExistingData: 'ஏற்கனவே உள்ள புலத் தரவை மேலெழுது',
    pageNotFound: 'பக்கம் கிடைக்கவில்லை',
    password: 'கடவுச்சொல்',
    pasteField: 'புலத்தை ஒட்டு',
    pasteRow: 'வரிசையை ஒட்டு',
    payloadSettings: 'Payload அமைப்புகள்',
    permanentlyDelete: 'நிரந்தரமாக நீக்கு',
    permanentlyDeletedCountSuccessfully: '{{count}} {{label}} நிரந்தரமாக நீக்கப்பட்டது.',
    perPage: 'ஒரு பக்கத்தில்: {{limit}}',
    previous: 'முந்தையது',
    reindex: 'மறுஅட்டவணை',
    reindexingAll: 'அனைத்து {{collections}} மறுஅட்டவணை செய்யப்படுகிறது.',
    remove: 'நீக்கு',
    rename: 'பெயர் மாற்று',
    reset: 'மீட்டமை',
    resetPreferences: 'அமைப்புகளை மீட்டமை',
    resetPreferencesDescription:
      'இது உங்கள் அனைத்து விருப்பங்களையும் இயல்புநிலை அமைப்புகளுக்கு மாற்றும்.',
    resettingPreferences: 'அமைப்புகள் மீட்டமைக்கப்படுகிறது.',
    restore: 'மீட்டமை',
    restoreAsPublished: 'வெளியிடப்பட்ட பதிப்பாக மீட்டமை',
    restoredCountSuccessfully: '{{count}} {{label}} வெற்றிகரமாக மீட்டமைக்கப்பட்டது.',
    restoring: 'மீட்டமைக்கிறது...',
    row: 'வரிசை',
    rows: 'வரிசைகள்',
    save: 'சேமி',
    saving: 'சேமிக்கிறது...',
    schedulePublishFor: '{{title}} வெளியீட்டை திட்டமிடு',
    searchBy: '{{label}} மூலம் தேடு',
    select: 'தேர்வு செய்',
    selectAll: 'அனைத்து {{count}} {{label}}-ஐத் தேர்ந்தெடு',
    selectAllRows: 'அனைத்து வரிசைகளையும் தேர்ந்தெடு',
    selectedCount: '{{count}} {{label}} தேர்ந்தெடுக்கப்பட்டது',
    selectLabel: '{{label}}-ஐத் தேர்ந்தெடு',
    selectValue: 'ஒரு மதிப்பைத் தேர்ந்தெடு',
    showAllLabel: 'அனைத்து {{label}}-ஐக் காட்டு',
    sorryNotFound: 'மன்னிக்கவும் — உங்கள் கோரிக்கைக்கு பொருந்த எதுவும் இல்லை.',
    sort: 'வரிசைப்படுத்து',
    sortByLabelDirection: '{{label}}-ஐ {{direction}} வரிசைப்படுத்து',
    stayOnThisPage: 'இந்தப் பக்கத்தில் இரு',
    submissionSuccessful: 'சமர்ப்பிப்பு வெற்றிகரமாக முடிந்தது.',
    submit: 'சமர்ப்பி',
    submitting: 'சமர்ப்பிக்கிறது...',
    success: 'வெற்றி',
    successfullyCreated: '{{label}} வெற்றிகரமாக உருவாக்கப்பட்டது.',
    successfullyDuplicated: '{{label}} வெற்றிகரமாக நகலெடுக்கப்பட்டது.',
    successfullyReindexed:
      '{{collections}} இலிருந்து மொத்த {{total}} ஆவணங்களில் {{count}} ஆவணங்கள் வெற்றிகரமாக மறுஇன்டெக்ஸ் செய்யப்பட்டன, மேலும் {{skips}} வரைவு எடுக்க முடியவில்லை.',
    takeOver: 'கையகப்படுத்து',
    thisLanguage: 'தமிழ்',
    time: 'நேரம்',
    timezone: 'நேர மண்டலம்',
    titleDeleted: '{{label}} "{{title}}" வெற்றிகரமாக நீக்கப்பட்டது.',
    titleRestored: '{{label}} "{{title}}" வெற்றிகரமாக மீட்டமைக்கப்பட்டது.',
    titleTrashed: '{{label}} "{{title}}" குப்பைக்குச் செலுத்தப்பட்டது.',
    trash: 'குப்பை',
    trashedCountSuccessfully: '{{count}} {{label}} குப்பைக்குச் செலுத்தப்பட்டது.',
    true: 'உண்மை',
    unauthorized: 'அனுமதி இல்லை',
    unlock: 'திறக்க',
    unsavedChanges:
      'சேமிக்கப்படாத மாற்றங்கள் உள்ளன. தொடருவதற்கு முன் சேமிக்கவும் அல்லது நிராகரிக்கவும்.',
    unsavedChangesDuplicate: 'சேமிக்கப்படாத மாற்றங்கள் உள்ளன. நகலெடுக்கத் தொடர விரும்புகிறீர்களா?',
    untitled: 'தலைப்பிடப்படாதது',
    upcomingEvents: 'வரவிருக்கும் நிகழ்ச்சிகள்',
    updatedAt: 'புதுப்பிக்கப்பட்ட நேரம்',
    updatedCountSuccessfully: '{{count}} {{label}} வெற்றிகரமாக புதுப்பிக்கப்பட்டது.',
    updatedLabelSuccessfully: '{{label}} வெற்றிகரமாக புதுப்பிக்கப்பட்டது.',
    updatedSuccessfully: 'வெற்றிகரமாக புதுப்பிக்கப்பட்டது.',
    updateForEveryone: 'அனைவருக்கும் புதுப்பி',
    updating: 'புதுப்பிக்கிறது',
    uploading: 'பதிவேற்றுகிறது',
    uploadingBulk: '{{total}}-இல் {{current}} பதிவேற்றுகிறது',
    user: 'பயனர்',
    username: 'பயனர்பெயர்',
    users: 'பயனர்கள்',
    value: 'மதிப்பு',
    viewing: 'பார்க்கிறது',
    viewReadOnly: 'வாசிப்பதற்கே காட்டு',
    welcome: 'வரவேற்பு',
    yes: 'ஆம்',
  },
  localization: {
    cannotCopySameLocale: 'அதே மொழி அமைவுக்கு நகலெடுக்க முடியாது',
    copyFrom: 'இதிலிருந்து நகலெடு',
    copyFromTo: '{{from}} இலிருந்து {{to}} வரை நகலெடுக்கிறது',
    copyTo: 'இதற்கு நகலெடு',
    copyToLocale: 'மொழி அமைவுக்கு நகலெடு',
    localeToPublish: 'வெளியிட வேண்டிய மொழி அமைவு',
    selectedLocales: 'தேர்வு செய்யப்பட்ட மொழிபெயர்ப்புகள்',
    selectLocaleToCopy: 'நகலெடுக்க வேண்டிய மொழி அமைவைத் தேர்ந்தெடுக்கவும்',
    selectLocaleToDuplicate: 'மறுநகலெடுக்க உள்ளடக்க வடவிட்டஈ',
  },
  operators: {
    contains: 'உள்ளடக்குகிறது',
    equals: 'சமம்',
    exists: 'உள்ளது',
    intersects: 'ஒட்டுகிறது',
    isGreaterThan: 'விட அதிகம்',
    isGreaterThanOrEqualTo: 'விட அதிகம் அல்லது சமம்',
    isIn: 'உள்ளது',
    isLessThan: 'விட குறைவு',
    isLessThanOrEqualTo: 'விட குறைவு அல்லது சமம்',
    isLike: 'போல உள்ளது',
    isNotEqualTo: 'சமமில்லை',
    isNotIn: 'இல்லை',
    isNotLike: 'போல இல்லை',
    near: 'அருகில்',
    within: 'உள்ளே',
  },
  upload: {
    addFile: 'கோப்பை சேர்க்கவும்',
    addFiles: 'கோப்புகளை சேர்க்கவும்',
    bulkUpload: 'மொத்தமாக பதிவேற்றம்',
    crop: 'வெட்டுக',
    cropToolDescription:
      'தேர்ந்த பகுதியின் மூலைகளை இழுத்து, புதிய பகுதியை வரையுங்கள் அல்லது கீழே உள்ள மதிப்புகளைச் சரிசெய்யவும்.',
    download: 'பதிவிறக்கம்',
    dragAndDrop: 'கோப்பை இழுத்து விடுக',
    dragAndDropHere: 'அல்லது கோப்பை இங்கே இழுத்து விடுக',
    editImage: 'படத்தை திருத்துக',
    fileName: 'கோப்புப் பெயர்',
    fileSize: 'கோப்பின் அளவு',
    filesToUpload: 'பதிவேற்ற வேண்டிய கோப்புகள்',
    fileToUpload: 'பதிவேற்ற வேண்டிய கோப்பு',
    focalPoint: 'கவனம் செலுத்தும் புள்ளி',
    focalPointDescription:
      'முன்னோட்டத்தில் புள்ளியை நேரடியாக இழுத்து விடவும் அல்லது கீழே உள்ள மதிப்புகளை மாற்றவும்.',
    height: 'உயரம்',
    lessInfo: 'குறைந்த தகவல்',
    moreInfo: 'மேலும் தகவல்',
    noFile: 'கோப்பு இல்லை',
    pasteURL: 'URL ஒட்டுக',
    previewSizes: 'முன்னோட்ட அளவுகள்',
    selectCollectionToBrowse: 'உலாவ தொகுப்பைத் தேர்ந்தெடுக்கவும்',
    selectFile: 'கோப்பைத் தேர்ந்தெடுக்கவும்',
    setCropArea: 'வெட்டும் பகுதியை அமைக்கவும்',
    setFocalPoint: 'கவனப்புள்ளியை அமைக்கவும்',
    sizes: 'அளவுகள்',
    sizesFor: '{{label}} க்கான அளவுகள்',
    width: 'அகலம்',
  },
  validation: {
    emailAddress: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
    enterNumber: 'சரியான எண் ஒன்றை உள்ளிடவும்.',
    fieldHasNo: 'இந்த புலத்தில் {{label}} இல்லை',
    greaterThanMax: '{{value}} அதிகபட்சமாக அனுமதிக்கப்பட்ட {{label}} {{max}}-ஐ விட அதிகமாக உள்ளது.',
    invalidBlock: '"{{block}}" அனுமதிக்கப்படாது.',
    invalidBlocks: 'இந்த புலம் இனி அனுமதிக்கப்படாத தொகுதிகளைக் கொண்டுள்ளது: {{blocks}}.',
    invalidInput: 'இந்த புலத்தில் தவறான உள்ளீடு உள்ளது.',
    invalidSelection: 'இந்த புலத்தில் தவறான தேர்வு உள்ளது.',
    invalidSelections: 'இந்த புலத்தில் பின்வரும் தவறான தேர்வுகள் உள்ளன:',
    latitudeOutOfBounds: 'அகலாங்கம் -90 மற்றும் 90 இடையே இருக்க வேண்டும்.',
    lessThanMin: '{{value}} குறைந்தபட்சமாக அனுமதிக்கப்பட்ட {{label}} {{min}}-ஐ விட குறைவாக உள்ளது.',
    limitReached: 'வரம்பு எட்டப்பட்டுள்ளது, {{max}} உருப்படிகள் மட்டுமே சேர்க்கப்படலாம்.',
    longerThanMin:
      'இந்த மதிப்பு குறைந்தபட்ச நீளமான {{minLength}} எழுத்துக்களை விட நீளமாக இருக்க வேண்டும்.',
    longitudeOutOfBounds: 'தீர்க்கக் கூறு -180 மற்றும் 180 இடையே இருக்க வேண்டும்.',
    notValidDate: '"{{value}}" ஒரு சரியான தேதி அல்ல.',
    required: 'இந்த புலம் அவசியம்.',
    requiresAtLeast: 'இந்த புலம் குறைந்தது {{count}} {{label}} தேவைப்படுகிறது.',
    requiresNoMoreThan: 'இந்த புலம் அதிகபட்சம் {{count}} {{label}} மட்டுமே அனுமதிக்கிறது.',
    requiresTwoNumbers: 'இந்த புலத்தில் இரண்டு எண்கள் தேவை.',
    shorterThanMax:
      'இந்த மதிப்பு அதிகபட்ச நீளமான {{maxLength}} எழுத்துக்களை விட குறைவாக இருக்க வேண்டும்.',
    timezoneRequired: 'ஒரு நேர மண்டலம் தேவைப்படுகிறது.',
    trueOrFalse: 'இந்த புலம் true அல்லது false ஆக மட்டுமே இருக்க வேண்டும்.',
    username:
      'சரியான பயனர் பெயரை உள்ளிடவும். எழுத்துக்கள், எண்கள், ஹைஃபன்கள், புள்ளிகள் மற்றும் அடிக்கோடுகள் இருக்கலாம்.',
    validUploadID: 'இந்த புலம் சரியான பதிவேற்ற ID அல்ல.',
  },
  version: {
    type: 'வகை',
    aboutToPublishSelection:
      'நீங்கள் தேர்வில் உள்ள அனைத்து {{label}}-ஐ வெளியிடப் போகிறீர்கள். உறுதியா?',
    aboutToRestore:
      'நீங்கள் இந்த {{label}} ஆவணத்தை {{versionDate}} அன்று இருந்த நிலைக்கு மீட்டமைக்கப் போகிறீர்கள்.',
    aboutToRestoreGlobal:
      'நீங்கள் உலகளாவிய {{label}}-ஐ {{versionDate}} அன்று இருந்த நிலைக்கு மீட்டமைக்கப் போகிறீர்கள்.',
    aboutToRevertToPublished:
      'இந்த ஆவணத்தின் மாற்றங்களை வெளியிடப்பட்ட நிலைக்கு மாற்றப்போகிறீர்கள். உறுதியா?',
    aboutToUnpublish: 'இந்த ஆவணத்தை வெளியிடாமல் செய்யப் போகிறீர்கள். உறுதியா?',
    aboutToUnpublishSelection:
      'நீங்கள் தேர்வில் உள்ள அனைத்து {{label}}-ஐ வெளியிடாமல் செய்யப் போகிறீர்கள். உறுதியா?',
    autosave: 'தானியங்க சேமிப்பு',
    autosavedSuccessfully: 'தானியங்க சேமிப்பு வெற்றிகரமாக முடிந்தது.',
    autosavedVersion: 'தானியங்க சேமிக்கப்பட்ட பதிப்பு',
    changed: 'மாற்றப்பட்டது',
    changedFieldsCount_one: '{{count}} புலம் மாற்றப்பட்டது',
    changedFieldsCount_other: '{{count}} புலங்கள் மாற்றப்பட்டன',
    compareVersion: 'பதிப்பை ஒப்பிடவும்:',
    compareVersions: 'பதிப்புகளை ஒப்பிடவும்',
    comparingAgainst: 'இதனுடன் ஒப்பிடப்படுகிறது',
    confirmPublish: 'வெளியீட்டை உறுதிப்படுத்தவும்',
    confirmRevertToSaved: 'சேமித்த நிலைக்கு மாற்றத்தை உறுதிப்படுத்தவும்',
    confirmUnpublish: 'வெளியீட்டை நீக்குவதை உறுதிப்படுத்தவும்',
    confirmVersionRestoration: 'பதிப்பு மீட்பை உறுதிப்படுத்தவும்',
    currentDocumentStatus: 'தற்போதைய {{docStatus}} ஆவணம்',
    currentDraft: 'தற்போதைய வரைவு',
    currentlyPublished: 'தற்போது வெளியிடப்பட்டுள்ளது',
    currentlyViewing: 'தற்போது காணப்படுகிறது',
    currentPublishedVersion: 'தற்போதைய வெளியிடப்பட்ட பதிப்பு',
    draft: 'வரைவு',
    draftHasPublishedVersion: 'வரைவு (வெளியிடப்பட்ட பதிப்பு உள்ளது)',
    draftSavedSuccessfully: 'வரைவு வெற்றிகரமாக சேமிக்கப்பட்டது.',
    lastSavedAgo: 'கடைசியாக {{distance}} முன்பு சேமிக்கப்பட்டது',
    modifiedOnly: 'மாற்றப்பட்டவை மட்டும்',
    moreVersions: 'மேலும் பதிப்புகள்...',
    noFurtherVersionsFound: 'மேலும் பதிப்புகள் எதுவும் கிடைக்கவில்லை',
    noLabelGroup: 'பெயரிடப்படாத குழு',
    noRowsFound: '{{label}} எதுவும் கிடைக்கவில்லை',
    noRowsSelected: '{{label}} எதுவும் தேர்வு செய்யப்படவில்லை',
    preview: 'முன் நோக்கு',
    previouslyDraft: 'முந்தைய வரைவு',
    previouslyPublished: 'முந்தைய வெளியீடு',
    previousVersion: 'முந்தைய பதிப்பு',
    problemRestoringVersion: 'இந்த பதிப்பை மீட்டமைக்க சிக்கல் ஏற்பட்டது',
    publish: 'வெளியிடு',
    publishAllLocales: 'அனைத்து மொழிகளிலும் வெளியிடு',
    publishChanges: 'மாற்றங்களை வெளியிடு',
    published: 'வெளியிடப்பட்டது',
    publishIn: '{{locale}}-இல் வெளியிடு',
    publishing: 'வெளியிடப்படுகிறது...',
    restoreAsDraft: 'வரைவாக மீட்டமை',
    restoredSuccessfully: 'வெற்றிகரமாக மீட்டமைக்கப்பட்டது.',
    restoreThisVersion: 'இந்த பதிப்பை மீட்டமை',
    restoring: 'மீட்டமைக்கப்படுகிறது...',
    reverting: 'மாற்றப்படுகிறது...',
    revertToPublished: 'வெளியிடப்பட்ட நிலைக்கு மாற்று',
    saveDraft: 'வரைவை சேமிக்கவும்',
    scheduledSuccessfully: 'அட்டவணைப்படுத்தப்பட்டது வெற்றிகரமாக.',
    schedulePublish: 'வெளியீட்டை அட்டவணைப்படுத்தவும்',
    selectLocales: 'காண்பிக்க மொழிகளைத் தேர்வு செய்க',
    selectVersionToCompare: 'ஒப்பிட ஒரு பதிப்பைத் தேர்வு செய்க',
    showingVersionsFor: 'இதற்கான பதிப்புகளை காட்டுகிறது:',
    showLocales: 'மொழிகளை காட்டு:',
    specificVersion: 'குறிப்பிட்ட பதிப்பு',
    status: 'நிலை',
    unpublish: 'வெளியீட்டை நீக்கு',
    unpublishing: 'வெளியீடு நீக்கப்படுகிறது...',
    version: 'பதிப்பு',
    versionAgo: '{{distance}} முன்பு',
    versionCount_many: '{{count}} பதிப்புகள் கிடைத்தன',
    versionCount_none: 'பதிப்புகள் எதுவும் கிடைக்கவில்லை',
    versionCount_one: '{{count}} பதிப்பு கிடைத்தது',
    versionCount_other: '{{count}} பதிப்புகள் கிடைத்தன',
    versionID: 'பதிப்பு ஐடி',
    versions: 'பதிப்புகள்',
    viewingVersion: '{{entityLabel}} {{documentTitle}}-க்கான பதிப்பைப் பார்க்கிறது',
    viewingVersionGlobal: 'உலகளாவிய {{entityLabel}}-க்கான பதிப்பைப் பார்க்கிறது',
    viewingVersions: '{{entityLabel}} {{documentTitle}}-க்கான பதிப்புகளைப் பார்க்கிறது',
    viewingVersionsGlobal: 'உலகளாவிய {{entityLabel}}-க்கான பதிப்புகளைப் பார்க்கிறது',
  },
}

export const ta: Language = {
  dateFNSKey: 'ta',
  translations: taTranslations,
}
